import { route} from 'preact-router';
import { useState, useEffect } from 'preact/hooks';
import useApp from '../context/AppContext';
import {useToaster} from '../context/ToasterContext';
import FormEvent from '../components/ui/FormEvent';
import useEvent from '../hooks/useEvent';

export default function FormEventFarrow(_route) {
    const { animals, events } = useApp();
    if (typeof animals == 'undefined' || animals === null) {
        return (
            <div class="text-center">
                <div class="spinner-border text-warning" role="status">
                    <span class="visually-hidden">Loading animals...</span>
                </div>
            </div>
        );
    }
    const { getEventInfo, saveEvent } = useEvent();
    const addToast = useToaster();
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
    const [numberOfBirth, setNumberOfBirth] = useState(1);
    const [eventInfo, setEventInfo] = useState(getEventInfo(_route, animals, events));
    const selectedAnimals = eventInfo.selectedAnimals;
    eventInfo.isCreateEvent = typeof _route.id == "undefined" || _route.id == "";
    eventInfo.isUnique = _route.animal_id;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function handleSubmit(e) {
        e.preventDefault();
        e.returnValue = '';
        const fields = e.target;
        let formAnimal = false;
        setNumberOfBirth(fields.numberOfBirth.value);
        // add +x to mother's followed if this is a new event
        if (!_route.id) {
            formAnimal = {
                followed: selectedAnimals[0].followed ?  parseInt(selectedAnimals[0].followed) + parseInt(numberOfBirth) : parseInt(numberOfBirth),
                driedup: false,
            }           
        }
        const formEvent = {
            date: fields.date.value,
            notes: fields.notes.value,
            type: 5,
        }
        setSubmitButtonDisabled(true);
        saveEvent(selectedAnimals, formEvent, formAnimal, _route, true).then((responses) => {
            let warning = false;
            setSubmitButtonDisabled(false);
            responses.map(response => {
                if (response.type == 'danger' || response.type == 'warning') warning = true;
                addToast(response.type, response.message);
            })
            if (!warning && fields.numberOfBirth.value > 0) {
                route('/form-animal/birth/mother/' + _route.animal_id + '/nob/' + numberOfBirth + '/bnum/1/date/' + formEvent.date);
            }
            else if (!warning) {
                history.go(-1);
            }
        });
    }

    return (
        <FormEvent title="Mise bas" 
            onSubmit={handleSubmit}
            eventInfo={eventInfo}
            message="" 
            submitButtonDisabled={submitButtonDisabled} 
            setEventInfo={setEventInfo}>
            
                    <div class="form-floating  mb-3">
                        <input class="form-control" id="numberOfBirth" type="number" name="numberOfBirth" defaultValue={eventInfo.isCreateEvent ? "1" : ""} onChange={(e) => {setNumberOfBirth(e.currentTarget.value)}} />
                        <label class="form-label" for="numberOfBirth">Nombre de naissances</label>
                    </div>
        </FormEvent>
    );
}